import React from 'react';
import Icon from '../../../components/AppIcon';

const roleLabels = {
  administrator: 'Administrator',
  user: 'User',
  view_only: 'View Only',
};

const roleDescriptions = {
  administrator: 'Full system access — manage users, settings, and all project data',
  user: 'Standard access — view and edit projects, bids, and resources',
  view_only: 'Read-only access — view data without editing permissions',
};

const roleIcons = {
  administrator: 'ShieldCheck',
  user: 'User',
  view_only: 'Eye',
};

const InvitationDetailsCard = ({ invitation }) => {
  const role = invitation?.role || 'user';
  const invitedByName = invitation?.invited_by_name || 'A team administrator';
  const companyName = invitation?.company_name || 'ConstructionPro';
  const invitedAt = invitation?.created_at
    ? new Date(invitation.created_at)?.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : null;
  const expiresAt = invitation?.expires_at
    ? new Date(invitation.expires_at)?.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : null;

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      {/* Header Banner */}
      <div className="bg-gradient-to-r from-amber-500 to-orange-500 px-6 py-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
            <Icon name="Mail" size={20} color="#FFFFFF" />
          </div>
          <div>
            <p className="text-white/80 text-xs font-medium uppercase tracking-wider">You've been invited to join</p>
            <h3 className="text-white font-bold text-lg leading-tight">{companyName}</h3>
          </div>
        </div>
      </div>
      {/* Details Grid */}
      <div className="p-5 space-y-4">
        {/* Role */}
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-lg bg-amber-50 border border-amber-100 flex items-center justify-center flex-shrink-0">
            <Icon name={roleIcons?.[role] || 'User'} size={16} className="text-amber-600" />
          </div>
          <div>
            <p className="text-xs text-gray-500 font-medium">Assigned Role</p>
            <p className="text-sm font-semibold text-gray-900">{roleLabels?.[role] || role}</p>
            <p className="text-xs text-gray-500 mt-0.5">{roleDescriptions?.[role]}</p>
          </div>
        </div>

        <div className="border-t border-gray-100" />

        {/* Invited By */}
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-lg bg-blue-50 border border-blue-100 flex items-center justify-center flex-shrink-0">
            <Icon name="UserCheck" size={16} className="text-blue-600" />
          </div>
          <div>
            <p className="text-xs text-gray-500 font-medium">Invited By</p>
            <p className="text-sm font-semibold text-gray-900">{invitedByName}</p>
          </div>
        </div>

        {invitedAt && (
          <>
            <div className="border-t border-gray-100" />
            <div className="flex items-start gap-3">
              <div className="w-9 h-9 rounded-lg bg-green-50 border border-green-100 flex items-center justify-center flex-shrink-0">
                <Icon name="Calendar" size={16} className="text-green-600" />
              </div>
              <div>
                <p className="text-xs text-gray-500 font-medium">Invitation Date</p>
                <p className="text-sm font-semibold text-gray-900">{invitedAt}</p>
                {expiresAt && (
                  <p className="text-xs text-orange-600 mt-0.5">Expires {expiresAt}</p>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default InvitationDetailsCard;
